/* eslint-disable max-len */
import XdcQuestion from 'images/coin-pages/questions/xdc.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const xdcPage: ICoinPageData = {
  title: 'coin_1149',
  description: 'coin_1150',
  // description: 'coin_1151',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'XDC' }) }} />
  ),
  questionsBlock: {
    image: XdcQuestion,
    questions: [
      {
        title: 'coin_1152',
        answer: 'coin_1153',
      },
      {
        title: 'coin_1154',
        answer: 'coin_1155',
      },
      {
        title: 'coin_1156',
        answer: 'coin_1157',
      },
      {
        title: 'coin_1158',
        answer: 'coin_1159',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('XDC'),
    text: [],
    paragraphs: [
      {
        title: 'coin_1160',
        text: ['coin_1162'],
      },
      {
        title: 'coin_1161',
        text: ['coin_1163'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.whatTypesOfCryptoLoansAreThereAndHowCanIProfitFromIt],
  },
}
